import { module } from 'angular';

import { default as wallboardListName, WallboardList } from './wallboard-list.component.ajs';

export default module('contact.wallboard.configuration.wallboard-list', []).component(wallboardListName, new WallboardList()).name;
